import { AccountService, UserProfile } from "src/app/services/account.service";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-invoice-details",
  templateUrl: "./invoice-details.component.html",
  styleUrls: ["./invoice-details.component.scss"],
})
export class InvoiceDetailsComponent implements OnInit {
  today = new Date();
  @Input() invoice;
  profile: UserProfile;

  constructor(private _accService: AccountService) {
    this.profile = _accService.getUserProfile();
  }

  ngOnInit(): void {
  }

  get totalInvoiceComm() {
    return this.invoice.InvoiceComm.reduce(function (a, b) {
      return a + b.CommValue;
    }, 0);
  }

  // invoice =
  //   {
  //     Symbolname: "فوري للمدفوعات",
  //     InvoiceComm: [
  //       {
  //         CommName: "خدمات البورصة",
  //         CommValue: 0.47,
  //       },
  //       {
  //         CommName: "خدمات المقاصة ",
  //         CommValue: 0.47,
  //       },
  //       {
  //         CommName: "خدمات الهيئة ",
  //         CommValue: 3,
  //       },
  //       {
  //         CommName: "تامين المخاطر",
  //         CommValue: 0.23,
  //       },
  //       {
  //         CommName: "ضريبة الدمغة على التداول ",
  //         CommValue: 7,
  //       },
  //       {
  //         CommName: "أمين الحفظ",
  //         CommValue: 0.47,
  //       },
  //     ],
  //     PostedSerial: "20/6",
  //     InvoiceID: 6,
  //     InvoiceDate: "2020-10-01T00:00:00",
  //     GrossAmount: 4665.81,
  //     NetAmount: 4677.45,
  //     AvgPrice: 26.97,
  //     CostPrice: 27.03728323699422,
  //     Qty: 173,
  //     SymbolCode: "EGS745L1C014",
  //     TransactionType: "شراء",
  //     MarketId: "البورصة المصرية",
  //     BranchID: "( الفرع الرئيسي )",
  //     Orders: [
  //       {
  //         OrderNumber: 18,
  //         TransactionQty: 40,
  //         TransactionPrice: 26.97,
  //         TicketNo: "N000124344593",
  //       },
  //       {
  //         OrderNumber: 19,
  //         TransactionQty: 40,
  //         TransactionPrice: 26.97,
  //         TicketNo: "N000124344627",
  //       },
  //       {
  //         OrderNumber: 20,
  //         TransactionQty: 93,
  //         TransactionPrice: 26.97,
  //         TicketNo: "N000124344693",
  //       },
  //     ],
  //   }

}
